// sort-imports-ignore
// prettier-disable
// Ensure Sentry is initialized before React is imported Note: https://docs.sentry.io/platforms/javascript/guides/react/#apply-instrumentation-to-your-app
import './clients/sentry-instruments';

import React from 'react';

import { createRoot } from 'react-dom/client';

// prettier-disable
import './assets/scss/main-theme.scss';
import { App } from './root';
// prettier-disable
import { UiProvider } from 'ui';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <UiProvider
      theme={{
        components: {
          Modal: {
            defaultProps: {
              yOffset: 'var(--safe-area-top, 5dvh)',
            },
          },
        },
      }}
    >
      <App />
    </UiProvider>
  </React.StrictMode>
);
